import script from "./StaffDocumentPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./StaffDocumentPreview.vue?vue&type=script&setup=true&lang=ts"

import "./StaffDocumentPreview.vue?vue&type=style&index=0&id=95a8990e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95a8990e"]])

export default __exports__